import {observer} from "mobx-react-lite";
import React from "react";
import {Redirect} from "react-router";
import {useStores} from "../../stores/useStores";
import ErrorCard from "../../components/molecules/errorCard/errorCard";
import {RoutePaths} from "../../shared/routePaths";
import {useTranslation} from "react-i18next";
import {Button} from "reactstrap";
import {Link} from "react-router-dom";

const SignInRedirect: React.FC = () => {
  const {
    uiStore: {accountStore}
  } = useStores();
  const {t} = useTranslation(["translation"]);

  if (accountStore.isAuthenticated) {
    if (accountStore.isAuthorised) {
      return <Redirect to={RoutePaths.Home} />;
    } else {
      return (
        <ErrorCard
          title={t("translation:notSignedInTitle")}
          error={t("translation:notSignedInMessage")}
          resolution={t("translation:notSignedInResolution")}
        >
          <Button color="primary" to={RoutePaths.Home} tag={Link}>
            {t("translation:returnHome")}
          </Button>
        </ErrorCard>
      );
    }
  }
  window.location.href = accountStore.endpoints.signIn;
  return <></>;
};
export default observer(SignInRedirect);
